import { CourseExplorer } from "@components";
import { APP_TITLE_SUFFIX } from "@constants";
import React, { useLayoutEffect } from "react";

const ExplorePage = () => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects
  useLayoutEffect(() => {
    document.title = `Explore | ${APP_TITLE_SUFFIX}`;
    return () => {
      document.title = APP_TITLE_SUFFIX;
    };
  }, []);

  // render
  return (
    <CourseExplorer
      title="Explore Courses"
      extraSearchParams={{
        IsPurchased: false,
        IsEnrollemt: false,
        IsOwner: false,
      }}
    />
  );
};

/* required: display name */
ExplorePage.displayName = "ExplorePage";

/* required: props types */
ExplorePage.propTypes = {};

/* required: default props */
ExplorePage.defaultProps = {};

export { ExplorePage };
